export { default as Form } from 'exchange/components/form/ExchangeForm';



// WEBPACK FOOTER //
// src/modules/secured/modules/exchange/components/form/index.js